import { Typography, Box, Divider } from "@material-ui/core";
import clsx from "clsx";
import "./styles.scss";
import React from "react";
import { useDeviceTypes } from "halifax";
import { getConfigTenant, isVesperTenant } from "@capone/common";

interface Traveler {
  firstName: string;
  lastName: string;
}
interface FlightTravelerInformationReadOnlyProps {
  travelers: Traveler[];
}

export const FlightTravelerInformationReadOnly: React.FC<
  FlightTravelerInformationReadOnlyProps
> = ({ travelers }) => {
  const { matchesMobile } = useDeviceTypes();
  const isVesper = isVesperTenant(getConfigTenant());

  const travelerHeader = (() => {
    if (travelers.length === 0) return "No Adult";
    if (travelers.length === 1) return "1 Adult";
    return `${travelers.length} Adults`;
  })();
  const travelerList = travelers.map((traveler) => (
    <li
      className="flight-traveler-list-item"
      key={`${traveler.firstName}-${traveler.lastName}`}
    >
      <Typography variant="body2">
        {traveler.firstName} {traveler.lastName}
      </Typography>
    </li>
  ));
  return (
    <Box
      className={clsx("flight-traveler-information-root", {
        mobile: matchesMobile,
      })}
    >
      {matchesMobile && (
        <Box>
          <Typography variant="body1" className="flight-traveler-title">
            Traveler Information
          </Typography>
          {!isVesper && <Divider className="flight-traveler-information-container-divider" />}
        </Box>
      )}
      <Box>
        <Box>
          <Typography variant="body1" className="flight-traveler-number">
            {travelerHeader}
          </Typography>
          <ul className="flight-traveler-list">{travelerList}</ul>
        </Box>
      </Box>
      {!isVesper && <Divider className="flight-traveler-information-container-divider" />}
      <Typography
        variant="body2"
        className="flight-traveler-information-footer"
      >
        You will be changing the itinerary for all passengers on your original
        booking. If you would like to make changes for just one passenger,
        please give us a call at{" "}
        <a className="flight-traveler-information-tel" href="tel:844-422-6922">
          844-422-6922
        </a>
        .
      </Typography>
    </Box>
  );
};
